import React, { useState, useEffect, useMemo } from "react";
import './ChildServiceDetails.css';
import testImage from '../../../../assets/images/packages/test.png';
import { Title } from "../../../../components";
import { Accordion, Col, Row, Form,Container } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import debounce from "lodash.debounce";
import { useTranslation } from '../../../../contexts/TranslationContext';
import { axiosGet } from "../../../../utils/apis/api";
import Cookies from "js-cookie";



const ChildServiceDetails = ({ url, onNext, onBack, service,setSelectedDestination }) => {
    const { t } = useTranslation();
    const Lang = Cookies.get("preferred_language") || "en";

    console.log("service", service);
    const [form, setForm] = useState({ destination_country: null });
    const [childServiceData, setChildServiceData] = useState(null);

    const [errors, setErrors] = useState({});
    const [destQuery, setDestQuery] = useState("");
    const [destOptions, setDestOptions] = useState([]);
    const [destLoading, setDestLoading] = useState(false);


    const err = (field) => !!errors[field];


    const fetchDestinations = useMemo(
        () =>
            debounce(async (q = "") => {
                try {
                    setDestLoading(true);
                    const base = { location_type: "City", limit: 20 };
                    const params = q.length >= 2 ? { ...base, search: q } : base;

                    const json = await axiosGet(
                        "https://crm.alltimestravels.com/api/method/alltimes.www.api.locations",
                        params
                    );
                    setDestOptions(json?.result?.locations || []);
                } catch (error) {
                    console.error("Error fetching destinations:", error);
                } finally {
                    setDestLoading(false);
                }
            }, 300),
        []
    );

    useEffect(() => { if (destQuery.length >= 2) fetchDestinations(destQuery); }, [destQuery, fetchDestinations]);

    const fetchServiceByDestination = async (destinationId) => {
        if (!destinationId) return;

        try {

            const apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.service.service.service?parent_service=${encodeURIComponent(service.name)}&service_attr_value=${encodeURIComponent(destinationId)}`;
            const response = await axiosGet(apiUrl);

            console.log("API result for destination:", response?.result?.items?.[0]);
            setChildServiceData(response?.result?.items?.[0] || null);
        } catch (error) {
            console.error("Error fetching service details:", error);
        }
    };

    return (
        <Container>
            <div className="margin-top child-service-container">
                <div className=''>
                    <div className='main-title-first'>{t("DreamVacationDestination")}</div>
                    <div className='main-title-counter'>
                        <div className='main-title-second'>{t("Visa")}</div>
                    </div>
                    <div className='main-title-para child-service-para' >{"We offer hassle-free visa processing services to help you travel with confidence. Whether for tourism, business, or study, our experts guide you through the application process, ensuring a smooth and stress-free experience. Let us handle the paperwork while you focus on your journey."}</div>
                </div>
            </div>

            <div className="visa-info">
                <Accordion
                    className="hotel-form-accordion add-service-form-accordion services-visa-form-accordion-container"
                    defaultActiveKey={["0"]}
                   alwaysOpen
                >
                    <Accordion.Item eventKey="0" className="hotel-form-accordion-item" >
                        <Accordion.Header className="hotel-form-accordion-header child-service-title ">
                            {t("VisaInformation")}
                        </Accordion.Header>
                        <Accordion.Body className="hotel-form-accordion-body">
                            <Row>
                                {/* Destination Country */}
                                <Col xl={4} md={4}>
                                    <div
                                        className="hotel-form-input-container"
                                        id="field-destination_country"
                                    >
                                        <label className="hotel-form-input-label">
                                            {t("DestinationCountry")} <span>*</span>
                                        </label>
                                        <Autocomplete
                                            options={destOptions}
                                            loading={destLoading}
                                            getOptionLabel={(o) => {
                                                const city = (o.location_name || "")
                                                    .replace(/\s+/g, " ")
                                                    .trim();
                                                const parent = (o.parent_location_name || "")
                                                    .replace(/\s+/g, " ")
                                                    .trim();
                                                return parent ? `${city} (${parent})` : city;
                                            }}
                                            value={
                                                form.destination_country
                                                    ? {
                                                        name: form.destination_country,
                                                        location_name: form.destination_country_name || "",
                                                    }
                                                    : null
                                            }
                                            onOpen={() => {
                                                if (!destOptions.length) fetchDestinations();
                                            }}
                                            onInputChange={(_, v, reason) => {
                                                if (reason === "input") setDestQuery(v);
                                            }}
                                            //   onChange={(_, v) =>
                                            //       setForm((p) => ({
                                            //           ...p,
                                            //           destination_country: v?.name || null,
                                            //           destination_country_name: v?.location_name || "",
                                            //       }))
                                            //   }
                                            onChange={(_, v) => {
                                                setForm((p) => ({
                                                    ...p,
                                                    destination_country: v?.name || null,
                                                    destination_country_name: v?.location_name || "",
                                                }));

                                                if (v?.name) {
                                                    fetchServiceByDestination(v.name);
                                                    setSelectedDestination({
                                                        name: v.name,
                                                        location_name: v.location_name,
                                                    });
                                                }
                                            }}
                                            sx={{
                                                ".MuiAutocomplete-inputRoot": {
                                                    fontSize: "12px",
                                                    flexDirection: Lang === "ar" ? "row-reverse" : "row",
                                                },
                                                ".MuiAutocomplete-endAdornment": {
                                                    left:
                                                        Lang === "ar" ? "9 !important" : "unset !important",
                                                    right:
                                                        Lang === "ar" ? "unset !important" : "9 !important",
                                                },
                                                ".MuiInputBase-input": {
                                                    textAlign: Lang === "ar" ? "right" : "left",
                                                },
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    size="small"
                                                    placeholder={t("SelectCountryOrCity")}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: {
                                                            direction: Lang === "ar" ? "rtl" : "ltr",
                                                        },
                                                        sx: {
                                                            backgroundColor: "#FFF",
                                                            borderRadius: "6px",
                                                            padding: "9px 15px !important",
                                                            fontFamily: '"Dmsans400"',
                                                            fontSize: "14px !important",
                                                            fontWeight: 400,
                                                            letterSpacing: "0.25px",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                        {err("destination_country") && (
                                            <div className="field-error">
                                                {errors.destination_country}
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1"
                        className={`hotel-form-accordion-item ${!form.destination_country ? 'disabled-accordion' : ''}`}
                        disabled={!form.destination_country}
                    >
                        <Accordion.Header className="hotel-form-accordion-header">
                            {t("Description")}
                        </Accordion.Header>
                        <Accordion.Body className="hotel-form-accordion-body">
                            {childServiceData ? (
                                <div dangerouslySetInnerHTML={{ __html: childServiceData.details }} />
                            ) : (
                                <p>{t("NoDescription")}</p>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className={`hotel-form-accordion-item ${!form.destination_country ? 'disabled-accordion' : ''}`}
                        disabled={!form.destination_country} >
                        <Accordion.Header className="hotel-form-accordion-header">
                            {t("Price")}
                        </Accordion.Header>
                        <Accordion.Body className="hotel-form-accordion-body">
                            {childServiceData ? (
                                <>
                                    <h5>{t("Price")}: {childServiceData.price} AED</h5>
                                    <div className="sevice-price-details" dangerouslySetInnerHTML={{ __html: childServiceData.price_details }} />
                                </>
                            ) : (
                                <p>{t("NoPriceInfo")}</p>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className={`hotel-form-accordion-item ${!form.destination_country ? 'disabled-accordion' : ''}`}
                        disabled={!form.destination_country} >
                        <Accordion.Header className="hotel-form-accordion-header">
                            {t("Terms")}
                        </Accordion.Header>
                        <Accordion.Body className="hotel-form-accordion-body">
                            {childServiceData ? (
                                <div dangerouslySetInnerHTML={{ __html: childServiceData.terms_and_conditions_details }} />
                            ) : (
                                <p>{t("NoTermsAvailable")}</p>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="mt-4 text-end">
                    <button
                        className="btn-next "
                        onClick={onNext}
                        disabled={!form.destination_country}
                    >
                        {t("Next")}
                    </button>
                </div>
            </div>
        </Container>

    );
};

export default ChildServiceDetails;
